import { Injectable } from '@nestjs/common';
import { SkuCodes } from '../sku-codes.entity';
import { SkuCodesDTO } from './sku-codes.dto';

@Injectable()
export class SkuCodesAdapter {
 
    /**
     * 
     * @param skuCodesDTO 
     * @param isUpdate 
     */
  public convertDtoToEntity(skuCodesDTO: SkuCodesDTO,  isUpdate: boolean = false ): SkuCodes {
    console.log(skuCodesDTO,'dto2')
    const skuCodes = new SkuCodes();
   
   // skuCodes.skuCode=skuCodesDTO.skuCode;
    skuCodes.foodTypeId=skuCodesDTO.foodTypeId;
    skuCodes.valueAdditionOneId=skuCodesDTO.valueAdditionOneId;
    skuCodes.valueAdditionTwoId=skuCodesDTO.valueAdditionTwoId;
    skuCodes.valueAdditionThreeId=skuCodesDTO.valueAdditionThreeId;
    skuCodes.valueAdditionFourId=skuCodesDTO.valueAdditionFourId;
    skuCodes.valueAdditionFiveId=skuCodesDTO.valueAdditionFiveId;
    skuCodes.variantCode=skuCodesDTO.variantCode;
    skuCodes.onlySalt=skuCodesDTO.onlySalt;
    skuCodes.sttpSalt=skuCodesDTO.sttpSalt;
    skuCodes.npSalt=skuCodesDTO.npSalt;
    skuCodes.cpSalt=skuCodesDTO.cpSalt;
    skuCodes.requiredCount=skuCodesDTO.requiredCount;
    skuCodes.minCount=skuCodesDTO.minCount;
    skuCodes.maxCount=skuCodesDTO.maxCount;
    skuCodes.lossOrGainPercentage=skuCodesDTO.lossOrGainPercentage;
    skuCodes.productId=skuCodesDTO.productId;
    skuCodes.gradeId=skuCodesDTO.gradeId;
    skuCodes.minglaze=skuCodesDTO.minglaze;
    skuCodes.maxglaze=skuCodesDTO.maxglaze;
    skuCodes.soakingStyle=skuCodesDTO.soakingStyle;
    skuCodes.soakingTime=skuCodesDTO.soakingTime;
    skuCodes.unitPrice=skuCodesDTO.unitPrice;
    skuCodes.isActive=skuCodesDTO.isActive==undefined?true:skuCodesDTO.isActive;
    skuCodes.shortCode=skuCodesDTO.shortCode;
    skuCodes.vendorCategory=skuCodesDTO.vendorCategory;
    skuCodes.taxName=skuCodesDTO.taxName;
    skuCodes.taxabilityType=skuCodesDTO.taxabilityType;
    skuCodes.typeOfSupply=skuCodesDTO.typeOfSupply;
    skuCodes.honHlYield=skuCodesDTO.honHlYield;
    skuCodes.hlToPeelingYield=skuCodesDTO.hlToPeelingYield;
    skuCodes.soakingYield=skuCodesDTO.soakingYield;
    skuCodes.cookingLessYield=skuCodesDTO.cookingLessYield;
    skuCodes.honToFgYield = skuCodesDTO.lossOrGainPercentage
    skuCodes.rateOfDuty=skuCodesDTO.rateOfDuty
    skuCodes.productCount = skuCodesDTO.productCount;
    skuCodes.countType = skuCodesDTO.countType;

    if (isUpdate) {
      skuCodes.updatedUser = skuCodesDTO.createdUser;
      skuCodes.skuCodeId=skuCodesDTO.skuCodeId;
    } else {
      skuCodes.isActive = true;
      skuCodes.createdUser = skuCodesDTO.createdUser;
    }
    console.log(skuCodes,'adapterDto')
   return skuCodes;
  }
  public convertDataToDto(skuCodesObject: any): SkuCodesDTO {
    const skuCodesDTO= new SkuCodesDTO;
    skuCodesDTO.skuCodeId=skuCodesObject.skuCodeId;
    // skuCodesDTO.skuCode=skuCodesObject.skuCode;
    skuCodesDTO.foodTypeId=skuCodesObject.foodTypeId;
    skuCodesDTO.valueAdditionOneId=skuCodesObject.valueAdditionOneId;
    skuCodesDTO.valueAdditionTwoId=skuCodesObject.valueAdditionTwoId;
    skuCodesDTO.valueAdditionThreeId=skuCodesObject.valueAdditionThreeId;
    skuCodesDTO.valueAdditionFourId=skuCodesObject.valueAdditionFourId;
    skuCodesDTO.valueAdditionFiveId=skuCodesObject.valueAdditionFiveId;
    skuCodesDTO.variantCode=skuCodesObject.variantCode;
    skuCodesDTO.onlySalt=skuCodesObject.onlySalt;
    skuCodesDTO.sttpSalt=skuCodesObject.sttpSalt;
    skuCodesDTO.npSalt=skuCodesObject.npSalt;
    skuCodesDTO.cpSalt=skuCodesObject.cpSalt;
    skuCodesDTO.requiredCount=skuCodesObject.requiredCount;
    skuCodesDTO.minCount=skuCodesObject.minCount;
    skuCodesDTO.maxCount=skuCodesObject.maxCount;
    skuCodesDTO.lossOrGainPercentage=skuCodesObject.lossOrGainPercentage;
    skuCodesDTO.productId=skuCodesObject.productId;
    skuCodesDTO.gradeId=skuCodesObject.gradeId;
    skuCodesDTO.minglaze=skuCodesObject.minglaze;
    skuCodesDTO.maxglaze=skuCodesObject.maxglaze;
    skuCodesDTO.soakingStyle=skuCodesObject.soakingStyle;
    skuCodesDTO.soakingTime=skuCodesObject.soakingTime;
    skuCodesDTO.isActive = skuCodesObject.isActive;
    skuCodesDTO.createdAt = skuCodesObject.createdAt;
    skuCodesDTO.updatedAt = skuCodesObject.updatedAt;
    skuCodesDTO.createdUser = skuCodesObject.createdUser;
    skuCodesDTO.updatedUser = skuCodesObject.updatedUser;
    skuCodesDTO.versionFlag = skuCodesObject.versionFlag;
    skuCodesDTO.minGrade = skuCodesObject.minGrade;
    skuCodesDTO.maxGrade = skuCodesObject.maxGrade;
    skuCodesDTO.unitPrice = skuCodesObject.unitPrice;
    return skuCodesDTO;
  }
  public convertEntityToDto(skuCodesObject: SkuCodes): SkuCodesDTO {
    const skuCodesDTO= new SkuCodesDTO;
    skuCodesDTO.skuCodeId=skuCodesObject.skuCodeId;
    // skuCodesDTO.skuCode=skuCodesObject.skuCode;
    skuCodesDTO.foodTypeId=skuCodesObject.foodTypeId;
    skuCodesDTO.valueAdditionOneId=skuCodesObject.valueAdditionOneId;
    skuCodesDTO.valueAdditionTwoId=skuCodesObject.valueAdditionTwoId;
    skuCodesDTO.valueAdditionThreeId=skuCodesObject.valueAdditionThreeId;
    skuCodesDTO.valueAdditionFourId=skuCodesObject.valueAdditionFourId;
    skuCodesDTO.valueAdditionFiveId=skuCodesObject.valueAdditionFiveId;
    skuCodesDTO.variantCode=skuCodesObject.variantCode;
    skuCodesDTO.onlySalt=skuCodesObject.onlySalt;
    skuCodesDTO.sttpSalt=skuCodesObject.sttpSalt;
    skuCodesDTO.npSalt=skuCodesObject.npSalt;
    skuCodesDTO.cpSalt=skuCodesObject.cpSalt;
    skuCodesDTO.requiredCount=skuCodesObject.requiredCount;
    skuCodesDTO.minCount=skuCodesObject.minCount;
    skuCodesDTO.maxCount=skuCodesObject.maxCount;
    skuCodesDTO.lossOrGainPercentage=skuCodesObject.lossOrGainPercentage;
    skuCodesDTO.productId=skuCodesObject.productId;
    skuCodesDTO.gradeId=skuCodesObject.gradeId;
    skuCodesDTO.minglaze=skuCodesObject.minglaze;
    skuCodesDTO.maxglaze=skuCodesObject.maxglaze;
    skuCodesDTO.soakingStyle=skuCodesObject.soakingStyle;
    skuCodesDTO.soakingTime=skuCodesObject.soakingTime;
    skuCodesDTO.isActive = skuCodesObject.isActive;
    skuCodesDTO.createdAt = skuCodesObject.createdAt;
    skuCodesDTO.updatedAt = skuCodesObject.updatedAt;
    skuCodesDTO.createdUser = skuCodesObject.createdUser;
    skuCodesDTO.updatedUser = skuCodesObject.updatedUser;
    skuCodesDTO.versionFlag = skuCodesObject.versionFlag;
    skuCodesDTO.shortCode = skuCodesObject.shortCode;
    skuCodesDTO.vendorCategory=skuCodesObject.vendorCategory;
    skuCodesDTO.taxName=skuCodesObject.taxName;
    skuCodesDTO.taxabilityType=skuCodesObject.taxabilityType;
    skuCodesDTO.typeOfSupply=skuCodesObject.typeOfSupply;
    skuCodesDTO.honHlYield=skuCodesObject.honHlYield;
    skuCodesDTO.hlToPeelingYield=skuCodesObject.hlToPeelingYield;
    skuCodesDTO.soakingYield=skuCodesObject.soakingYield;
    skuCodesDTO.cookingLessYield=skuCodesObject.cookingLessYield;
    skuCodesDTO.honToFgYield = skuCodesObject.lossOrGainPercentage
    skuCodesDTO.rateOfDuty=skuCodesObject.rateOfDuty
    skuCodesDTO.productCount = skuCodesObject.productCount;
    skuCodesDTO.countType = skuCodesObject.countType;
    return skuCodesDTO;
  }
}
